<template>
  <div class="renderPage ue-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="ue-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-circle-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase ue-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Mi Perfil
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="close()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- CONTENIDO -->
    <div class="ue-content pa-4">
      <v-form ref="form" v-model="valid">

        <!-- SECCIÓN: DATOS PERSONALES -->
        <div class="ue-section-label mb-3">
          <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-outline</v-icon>
          <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Datos Personales</span>
        </div>

        <v-card flat class="ue-section-card pa-4 mb-4">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editedItem.cedula"
                label="Cédula de Identidad"
                outlined
                dense
                readonly
                prepend-inner-icon="mdi-card-account-details-outline"
                class="ue-readonly-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre Completo"
                outlined
                dense
                prepend-inner-icon="mdi-account-outline"
                :rules="nameRules"
                required
                autocomplete="off"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <!-- SECCIÓN: SEGURIDAD -->
        <div class="ue-section-label mb-3">
          <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-lock-outline</v-icon>
          <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Seguridad</span>
        </div>

        <v-card flat class="ue-section-card pa-4 mb-4">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editedItem.clave"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Nueva Contraseña"
                outlined
                dense
                prepend-inner-icon="mdi-lock-outline"
                autocomplete="new-password"
                @click:append="showPassword = !showPassword"
                hint="Deja en blanco para mantener la actual"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

      </v-form>

      <!-- ACCIONES -->
      <div class="ue-footer d-flex justify-end pa-4" :class="$vuetify.theme.dark ? 'ue-footer--dark' : ''">
        <v-btn depressed class="ue-btn mr-3" :class="$vuetify.theme.dark ? 'blue-grey darken-3 white--text' : ''" @click="close()">
          <v-icon left small>mdi-arrow-left</v-icon> Regresar
        </v-btn>
        <v-btn color="primary" depressed class="ue-btn font-weight-bold" :loading="loading" @click="save">
          <v-icon left small>mdi-content-save-check-outline</v-icon> Actualizar Perfil
        </v-btn>
      </div>
    </div>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      loading: false,
      showPassword: false,
      valid: false,
      snackText: "",
      snackValue: false,
      editedItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
      },
      nameRules: [(v) => !!v || "El nombre es obligatorio"],
    };
  },

  computed: {
    ...mapGetters(["user"]),
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      let me = this;
      axios.get("api/Usuarios/getUsuario?usuarioId=" + this.user.id)
        .then(response => {
          me.editedItem = response.data;
          me.editedItem.clave = "";
        })
        .catch(err => console.error(err));
    },

    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let me = this;

      axios.post("api/Usuarios/updateUser", this.editedItem)
        .then(() => {
          me.snackText = "Tu perfil ha sido actualizado correctamente";
          me.snackValue = true;
          me.getData();
        })
        .catch(err => {
          console.error(err);
          me.snackText = "Error al actualizar la información";
          me.snackValue = true;
        })
        .finally(() => { this.loading = false; });
    },

    close() {
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.ue-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.ue-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.ue-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .ue-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.ue-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.ue-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== CONTENT ===== */
.ue-content {
  max-width: 700px;
  margin: 0 auto;
}

/* ===== SECTION LABEL ===== */
.ue-section-label {
  display: flex;
  align-items: center;
}

/* ===== SECTION CARD ===== */
.ue-section-card {
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
}
.theme--dark .ue-section-card {
  background-color: #1e293b !important;
  border-color: rgba(255, 255, 255, 0.07) !important;
}

/* ===== READONLY INPUT ===== */
.ue-readonly-input >>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.theme--dark .ue-readonly-input >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.03) !important;
}

/* ===== FOOTER ===== */
.ue-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0 0 6px 6px;
}
.ue-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}
</style>
